import { c as _c } from "react/compiler-runtime";
import { Clock as ClockIcon } from "lucide-react";
import { useEffect, useRef, useState } from "react";
const clockContent = {
  timeInSofia: "Time in Sofia: "
};
const getSofiaTimeString = () => {
  return new Date().toLocaleTimeString("en-US", {
    timeZone: "Europe/Sofia",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false
  });
};
export const Clock = () => {
  const $ = _c(5);
  const [timeString, setTimeString] = useState("00:00:00");
  const intervalRef = useRef(null);
  const rafRef = useRef(null);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const updateTime = () => {
        setTimeString(getSofiaTimeString());
      };
      const startClock = () => {
        updateTime();
        intervalRef.current = setInterval(updateTime, 1000);
      };
      rafRef.current = requestAnimationFrame(startClock);
      return () => {
        if (rafRef.current !== null) {
          cancelAnimationFrame(rafRef.current);
        }
        if (intervalRef.current) {
          clearInterval(intervalRef.current);
        }
      };
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <ClockIcon className="w-5 h-5" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== timeString) {
    t3 = <div className="flex items-center justify-center lg:justify-start gap-2 mb-6 pointer-events-none">{t2}<span className="body-base font-bold">{clockContent.timeInSofia} {timeString}</span></div>;
    $[3] = timeString;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};